import React from 'react';

const HeroSection = () => {
    return (
        <section className="section hero-section">
            <div className="container">
                <div className="hero-content">

                    <h1 className="hero-title">
                        Felipe Alexandre<br />
                        <span className="hero-title-accent">Bazzanella</span>
                    </h1>

                    <p className="hero-subtitle">
                        Senior Frontend Engineer specializing in ecommerce platforms.
                        Building high-performance, scalable storefronts with modern architecture
                        and exceptional user experiences.
                    </p>

                    <div className="hero-platforms">
                        <span className="badge badge--bigcommerce">BigCommerce</span>
                        <span className="badge badge--magento">Magento 2</span>
                        <span className="badge badge--shopware">Shopware 6</span>
                        <span className="badge badge--woocommerce">WooCommerce</span>
                    </div>

                    <div className="cta-group">
                        <a href="#projects" className="btn btn--primary btn--large">
                            View Projects
                        </a>
                        <a href="#contact" className="btn btn--hero-outline btn--large">
                            Contact Me
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HeroSection;